const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/HomeView.vue'),
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('@/views/AboutView.vue'),
  },
  {
    path: '/help',
    name: 'Help',
    component: () => import('@/views/HelpView.vue'),
  },
  {
    path: '/pantheon',
    name: 'Pantheon',
    component: () => import('@/views/PantheonView.vue'),
  },
  {
    path: '/pantheon/article/:id',
    name: 'PantheonArticle',
    component: () => import('@/views/PantheonArticleView.vue'),
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('@/views/ProfileView.vue'),
  },
  {
    path: '/data-warehouse',
    name: 'DataWarehouse',
    component: () => import('@/views/DataWarehouseView.vue'),
  },
  {
    path: '/data-workshop',
    name: 'DataWorkshop',
    component: () => import('@/views/DataWorkshopView.vue'),
  },
  {
    path: '/profile/publish',
    name: 'Publish',
    component: () => import('@/views/PublishView.vue'),
  },
  {
    path: '/messages/chat/:id',
    name: 'Chat',
    component: () => import('@/views/ChatView.vue'),
  },
  {
    path: '/settings',
    name: 'Settings',
    component: () => import('@/views/SettingsView.vue'),
    children: [
      { path: '', redirect: '/settings/profile' },
      { path: 'profile', component: () => import('@/views/settings/ProfileSettings.vue') },
      { path: 'general', component: () => import('@/views/settings/GeneralSettings.vue') },
      { path: 'notifications', component: () => import('@/views/settings/NotificationSettings.vue') },
      { path: 'privacy', component: () => import('@/views/settings/PrivacySettings.vue') },
    ],
  },
  {
    path: '/search',
    name: 'Search',
    component: () => import('@/views/SearchView.vue'),
  },
]

export default routes
